export const FAX_ACTION = {
  inbound: "VIEW_INBOUND_FAX",
  outbound: "VIEW_OUTBOUND_FAX",
  download: "DOWNLOAD_FAX",
  forwardToUser: "FORWARD_FAX",
  forwardToFax: "SEND_FAX",
  compose: "COMPOSE_FAX",
  delete: "DELETE_FAX",
  cancel: "CANCEL_FAX",
}

export const AUTH_EMAIL_APP_USER_REGISTRATION = "marie.gooneratne@consensus.com"

export const USER_ROLES = [
  { value: "ADMIN", label: "ADMIN" },
  { value: "USER", label: "USER" },
  { value: "SUPER_ADMIN", label: "SUPER_ADMIN" },
]

//export const DEFAULT_APP_ID = "5cf524a4-ba08-473e-ac73-99be98a0d693"
